<template>
  <CompletionChart
    label="What is our submission rate for race data?"
    :data="data"
    widget-download-id="race-survey-completion"
    tooltip-key="demo-survey-submission"
  />
</template>

<script setup>
import CompletionChart from '@/components/insights/ProcessInsights/DemographicSurveyReport/charts/CompletionChart.vue';
import { useDemographicSurveyReport } from '@/stores/insights/demographicSurveyReport';
import { storeToRefs } from 'pinia';

const { raceBreakdown } = storeToRefs(useDemographicSurveyReport());

const {
  asian = 0,
  black = 0,
  hispanic_latino: hispanicLatino = 0,
  native_american: nativeAmerican = 0,
  two_or_more: twoOrMore = 0,
  white = 0,
  pacific_islander: pacificIslander = 0,
  declined,
  unknown,
} = raceBreakdown.value;

const data = [
  asian + black + hispanicLatino
    + nativeAmerican + twoOrMore
    + white + pacificIslander,
  declined || 0,
  unknown || 0,
];
</script>
